import { IResponse } from 'app/shared/models/response';

export class ValidarResponse {
  private static RESPUESTA_OK = 'OK';

  public static validar(respuesta: IResponse): boolean {
    return respuesta.code === this.RESPUESTA_OK;
  }
}
